/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import { fetchEstate } from '../../lib/rest/estateAPIClient'
import EstateForm from './EstateForm'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import useParsedQueryParam from '../../../../client/js/hooks/useParsedQueryParam'
import { parseNumber } from '@jalik/form-parser'
import Page from '../../../../client/js/components/Page'
import EstateBreadcrumb from './EstateBreadcrumb'

function EstateFormPage () {
  const intl = useIntl()
  const params = useParams<{ id?: string }>()
  const estateId = parseInt(params.id, 10)
  const [searchParams] = useQueryParams()
  const ownerId = useParsedQueryParam('ownerId', parseNumber)

  const estateQuery = useQuery<Partial<Estate>>({
    enabled: true,
    queryKey: ['estate', estateId, searchParams],
    queryFn: () => estateId > 0
      ? fetchEstate(estateId)
      : Promise.resolve({
        ownerId
      } as Partial<Estate>),
    refetchOnWindowFocus: false
  })
  const { data } = estateQuery

  const title = useMemo(() => {
    if (estateId > 0 && data != null) {
      return data.reference
    }
    return intl.formatMessage({
      id: 'create_estate',
      defaultMessage: 'Créer un bien'
    })
  }, [data, estateId, intl])

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <EstateBreadcrumb
          estate={estateQuery.data}
          title={title}
        />

        <Card shadow="sm">
          <LoadingHelper
            query={estateQuery}
            render={() => (
              <EstateForm initialValues={data} />
            )}
          />
        </Card>
      </Container>
    </Page>
  )
}

export default EstateFormPage
